
import { AfterViewInit, Component, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Car } from 'app/models/car.model';
import { Container } from 'app/models/container.model';
import { Device } from 'app/models/device.model';
import { Envanter } from 'app/models/envanter.model';
import { Poligon, PoligonDetail } from 'app/models/poligon.model';
import { PoligonService } from 'app/services/poligon.service';
import { SimulationService } from 'app/services/simulation.service.js';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import * as L from 'leaflet';
import 'leaflet-draw';
import 'leaflet-easyprint';
import '../../../../../../../node_modules/leaflet.browser.print/dist/leaflet.browser.print.min.js';
import { GarbageCenterFormComponent } from '../garbage-center-form/garbage-center.component';
import { MapContainerFormComponent } from '../map-container-form/map-container-form.component';
import { MarkerFormComponent } from '../marker-form/marker-form.component';
import { PoligonFormComponent } from '../poligon-form/poligon-form.component';


const iconUrl = 'assets/img/marker-icon.png';
const iconDefault = L.icon({
    iconUrl,
    iconSize: [25, 25],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28]
});
const ContainerIcon = L.Icon.extend({
    options: {
        iconSize: [25, 25],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28]
    }
})
const LeafIcon = L.Icon.extend({
    options: {
        iconSize: [40, 40], //30,30
        iconAnchor: [5, 5], //12,41
        popupAnchor: [15, 0],//1,34
        tooltipAnchor: [16, -28],
        shadowAnchor: [4, 62]
    }
});

L.Marker.prototype.options.icon = iconDefault;

var pointInPolygon = require('point-in-polygon');

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [SimulationService]
})
export class SimulationMapComponent implements AfterViewInit {


    capitals: string = '/assets/data/usa-capitals.geojson';

    private map;
    public companyId: number
    public envanterMarkerOpen = false;
    public markerMasterOpen = false;
    public containerMarkerOpen = false;
    public markerOpen = false;
    private polygonMarkerOpen = false;
    private _containers: Array<Container> = [];
    private poligons = [];
    public envanterList:Array<Envanter> =[];
    public carlist: Array<Car>

    constructor(
        private _dialog: MatDialog,
        private _toastService: ToasterService,
        private _simulationService: SimulationService,
        private appConfigService: AppInitializationService,
        private _translateService:TranslateService
    ) {

    }
    public drawControl = new L.Control.Draw({
        position: 'topleft',
        draw: {
            polyline: true,
            polygon: true,
            circle: false,
            rectangle: false,
            marker: false,
            circlemarker: false,
        }
    });


    public get MapTileUrl(): string {
        return 'http://tile.openstreetmap.org/{z}/{x}/{y}.png';
    }

    private async getLocationList(): Promise<Array<Container>> {
        try {
            this._containers = await this._simulationService.getAllContainerDetail(parseInt(localStorage.getItem("CompanyID")));
        } catch (error) {
            console.warn(error);
            return [];
        }
    }

    private async initMap(): Promise<void> {
        try {

            this.companyId = parseInt(localStorage.getItem("CompanyID"));
            this.carlist = await this._simulationService.getCars(this.companyId);
        } catch (error) {
            console.warn(error);

        }
        this.map = L.map('map', {
            center: [39.09766, 34.56039],
            zoom: 6
        });

        this.drawInit(this.map);
        this.mySetLocation(this.map);

        const tiles = L.tileLayer(
            this.MapTileUrl, {
            maxZoom: 19,
            minZoom: 5,
            attribution: 'AKILLI-ATIK-SİSTEMİ'
        });
        tiles.addTo(this.map);

        L.control.browserPrint({position: 'topleft', title: 'Print ...'}).addTo(this.map);
        this.map.on('draw:drawstart', async e => {
            this.polygonMarkerOpen = true;
            if (this.markerOpen || this.markerMasterOpen || this.containerMarkerOpen) {
                this._toastService.toastFail(this._translateService.instant("STOP_MARKING"))
                this.map.removeControl(this.drawControl);
                this.map.addControl(this.drawControl)
            }
        });
        this.map.on('draw:drawstop', async e => {
            this.polygonMarkerOpen = false;
        });

        this.map.on("click", async e => {

            //konteyner ekleme 
            if (this.containerMarkerOpen && !this.markerOpen && !this.polygonMarkerOpen) {
                const dialog = this._dialog.open(MapContainerFormComponent, {
                    data: {lat:e.latlng.lat,lng:e.latlng.lng},
                    disableClose: false
                });

                dialog.componentInstance.operation = "create";
                dialog.componentInstance.added.subscribe(async (model: Container) => {

                    const marker = L.marker([e.latlng.lat, e.latlng.lng]);
                    const formModel = Object.assign({ lat: e.latlng.lat, lng: e.latlng.lng }, e);

                    model.latitude = e.latlng.lat;
                    model.longitude = e.latlng.lng;
                    let container;
                    try {
                        model.status = true;
                        await this.setDeviceMultiple(model.companyId,model.deviceId);
                        container = await this._simulationService.addContainer(model);

                    } catch (error) {
                        console.warn(error);

                    }

                    this.poligons.forEach(poligon => {
                        var poligonList = new Array();
                        let points = poligon.points.split("*");
                        points.forEach(item => {
                            var array = new Array();
                            var location = item.split([","]);
                            array.push(parseFloat(location[0]), parseFloat(location[1]))
                            poligonList.push(array);
                        });

                        var inPolygon = pointInPolygon([formModel.lat, formModel.lng], poligonList); // true
                        if (inPolygon) {
                            let poligonDetail = new PoligonDetail();
                            poligonDetail.poligonId = poligon.id;
                            poligonDetail.discriminator = "container";
                            poligonDetail.discriminatorId = container.id

                            try {
                                this.containerAdd(poligonDetail)
                            } catch (error) {
                                console.warn(error);

                            }
                        }
                    })

                    marker.addTo(this.map);
                    dialog.close();
                });
                dialog.afterClosed().subscribe(() => {
                    this.containerMarkerOpen = false;
                })
            }


            //konteyner konum belirleme
            if ((this.markerOpen) && !this.polygonMarkerOpen) {
                const marker = L.marker([e.latlng.lat, e.latlng.lng]);
                const formModel = Object.assign({ lat: e.latlng.lat, lng: e.latlng.lng }, e);
                const dialog = this._dialog.open(MarkerFormComponent, {
                    data: formModel,
                    disableClose: false
                });
                let control = false;

                dialog.componentInstance.done.subscribe(async () => {
                    this.markerOpen = false;
                    if(dialog.componentInstance.selectedContainer.containerType==true){
                        marker.addTo(this.map);
                        return;
                    }
                     this.poligons.forEach(poligon => {
                        var poligonList = new Array();
                        let points = poligon.points.split("*");
                        points.forEach(item => {
                            var array = new Array();
                            var location = item.split([","]);
                            array.push(parseFloat(location[0]), parseFloat(location[1]))
                            poligonList.push(array);
                        });

                        var inPolygon = pointInPolygon([formModel.lat, formModel.lng], poligonList); // true
                        if (inPolygon) {
                            control = true;
                            let poligonDetail = new PoligonDetail();
                            poligonDetail.poligonId = poligon.id;
                            poligonDetail.discriminator = "container";
                            poligonDetail.discriminatorId = dialog.componentInstance.selectedContainer.id

                            try {
                                this.containerAdd(poligonDetail)

                            } catch (error) {
                                console.warn(error);

                            }
                        }
                    })
                    marker.addTo(this.map);

                    if (!control) {
                        this.containerDeleteWithOutPolygon(dialog.componentInstance.selectedContainer.id)
                    }

                    this._toastService.toastSuccess();

                });

                dialog.componentInstance.close.subscribe(async (value: string) => {

                    this.markerOpen = false;

                    if (value != "") {
                        this._toastService.toastFail(value);
                    }

                    this.map.removeLayer(marker);
                });

            }

            //Boşaltım merkezi ekleme
            if ((this.markerMasterOpen) && !this.polygonMarkerOpen) {
                const marker = L.marker([e.latlng.lat, e.latlng.lng]);
                const formModel = Object.assign({ lat: e.latlng.lat, lng: e.latlng.lng }, e);
                const dialog = this._dialog.open(GarbageCenterFormComponent, {
                    data: formModel,
                    disableClose: false
                });

                dialog.componentInstance.done.subscribe(async () => {

                    this.markerOpen = false;

                    this.containerDeleteWithOutPolygon(dialog.componentInstance.selectedContainerId);
                    dialog.componentInstance.selectedPolygons.forEach(x=>{
                       
                        let poligonDetail = new PoligonDetail();
                         poligonDetail.poligonId = x.id;
                         poligonDetail.discriminator = "garbage-center";
                         poligonDetail.discriminatorId = dialog.componentInstance.selectedContainerId
                         this.containerAdd(poligonDetail)
                    })
                    marker.addTo(this.map);
                    this._toastService.toastSuccess();

                });

                dialog.componentInstance.close.subscribe(async (value: string) => {

                    this.markerOpen = false;

                    if (value != "") {
                        this._toastService.toastFail(value);
                    }

                    this.map.removeLayer(marker);
                });

            }
        });

    }
    public async containerDeleteWithOutPolygon(discriminator_Id: number) {
        try {
            var poligonDetailList = await this._simulationService.getByPoligonDetail(discriminator_Id);
            await this._simulationService.removeRange(poligonDetailList)
        } catch (error) {
            console.warn(error);

        }

    }


    public async containerAdd(poligonDetail: PoligonDetail) {
        try {
            var poligonDetailList = await this._simulationService.getByPoligonDetail(poligonDetail.discriminatorId);
            await this._simulationService.removeRange(poligonDetailList);
            await this._simulationService.addDetail(poligonDetail);
        } catch (error) {
            console.warn(error);

        }

    }


    public drawInit(map: L.map) {
        map.addControl(this.drawControl);
        map.on('draw:created', this.openPoligonForm.bind(this));
    }

    public polygonOverlappingControl(layer): Boolean {

        let selectedArray = [];
        let latLangs = layer._latlngs[0];
        let poligons = [];
        var inPolygonSecond;
        var inPolygon;
        var controlone = false;
        var controltwo = false;
        for (let index = 0; index < latLangs.length; index++) {
            let newLocation = [latLangs[index].lat, latLangs[index].lng];
            selectedArray.push(newLocation);
        }

        this.poligons.forEach(poligon => {
            var poligonList = new Array();
            let points = poligon.points.split("*");
            points.forEach(item => {
                var array = new Array();
                var location = item.split([","]);
                inPolygon = pointInPolygon([location[0], location[1]], selectedArray);

                if (inPolygon) {
                    controlone = true;
                }

                array.push(parseFloat(location[0]), parseFloat(location[1]))
                poligonList.push(array);
            });
            poligons.push(poligonList);
        })
        selectedArray.forEach(item => {
            poligons.forEach(element => {
                inPolygonSecond = pointInPolygon([item[0], item[1]], element);

                if (inPolygonSecond) {
                    controltwo = true;
                }

            });
        })
        return (controlone || controltwo) ? false : true;
    }

    public openPoligonForm(e) {

        if (e.layerType == "polyline") {
            this.multiContainerForm(e);
        } else {

            var layer = e.layer;
            var poligonInfo = "";
            let overlapping = this.polygonOverlappingControl(layer)
            if (overlapping) {
                for (let index = 0; index < layer._latlngs[0].length; index++) {
                    const element = layer._latlngs[0][index];

                    poligonInfo += element.lat + "," + element.lng;

                    if (index < layer._latlngs[0].length - 1) {
                        poligonInfo += "*";
                    }

                }
                const formModel = new Poligon();
                formModel.points = poligonInfo;

                const dialog = this._dialog.open(PoligonFormComponent, {
                    data: formModel,
                    disableClose: false
                });
                dialog.componentInstance.done.subscribe(async (id: string) => {

                    this.LocationsInsidePolygon(layer, id);
                    this.getPoligonList();
                    this.map.addLayer(layer);
                    this._toastService.toastSuccess();
                });
            }
            else {
                this._toastService.toastWarning(this._translateService.instant("THE_POLYGONS_OVERLAP"))
            }
        }

    }

    multiContainerForm(e) {
        const dialog = this._dialog.open(MapContainerFormComponent, {
            data: new Container(),
            disableClose: false
        });
        dialog.componentInstance.operation = "update";  // tekli ekleme create - çoklu ekleme update
        dialog.componentInstance.updated.subscribe((model: Container) => {
            this.setMarkerWithPolyline(e, model);
            this._toastService.toastSuccess();
            dialog.close();
        });
    }



    async setMarkerWithPolyline(e, model: Container) {
        var layer = e.layer;

        for (let index = 0; index < layer._latlngs.length; index++) {
            const element = layer._latlngs[index];

            var map_icon = new ContainerIcon({ iconUrl: 'assets/img/marker-icon.png' });
            const marker = L.marker([element.lat, element.lng], { icon: map_icon });
            marker.addTo(this.map);
            var deviceId = this.generateGuidMegEye();

            await this.setDeviceMultiple(model.companyId,deviceId);
            let container = new Container();
            container.deviceId = deviceId;
            container.latitude = element.lat;
            container.longitude = element.lng;
            container.companyId = model.companyId
            container.dDate = new Date();
            container.altitude = model.altitude;
            container.sValue = model.sValue;
            container.bValue = model.bValue;
            container.simulation = true;
            container.street = model.street + "/" + index;
            container.streetDesc = model.streetDesc + "/" + index;
            container.neighbor = model.neighbor + "/" + index;
            container.name= model.name + "/" +index
            container.status = true;
            try {
                let containerResponse = await this._simulationService.addContainer(container);
                this.DrawPolygonInContainerControl(containerResponse);

            } catch (error) {
                console.warn(error);

            }
        }
    }

    async setDeviceMultiple(companyId,deviceId):Promise<string> {
        var _device: Device =
        {
            
            id: deviceId,
            firmware: "00032",
            model: "2",
            periot: "15",
            shakeCount: "120",
            sonicActive: "1",
            sonicFilte: "10",
            sonicTolerans: "20",
            sonicMeasure: "15",
            msgTyr: "3",
            msgStanby: "35000",
            runType: "1",
            gpsRepeat: "20",
            gpsTime: "25",
            shakeWait:"3",
            distanceTime:"5",
            distanceValue:"15",
            empty1:"0",
            empty2:"0",
            empty3:"0",
            gpsPeriot: "8",
            batMin: "320",
            batGpMin: "380",
            batMultiplier: "1000",
            solarMultiplier: "1000",
            serialNumber: "DP0000000001",
            apn: "internet",
            hostRequestWeb: "http://212.154.111.45:10001",
            hostRequestEXT: "/custom_get_request",
            ssid: "Simulation",
            smsNumber: "5439024474",
            periotTimeOut: "20",
            heatAlarm:"800",
            updated: 0,
            companyId:companyId,
            time:new Date,
            uDate: new Date
        };
        try {
            await this._simulationService.addDevice(_device)
            return deviceId;
        } catch (error) {
            console.warn(error);
            return null;
        }
    }

    public generateGuidMegEye(): string {
        var toDate = new Date
        var full_date = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(),toDate.getHours(),toDate.getMinutes(),toDate.getSeconds(),toDate.getMilliseconds());
        var rn=Math.floor(Math.random()*1000000);
        var time = full_date.getTime();
        return "0"+(time.toString()+rn.toString()).slice(5, 20);
      }

    public LocationsInsidePolygon(layer, id) {
        //poligon içeriğini alma
        let array = [];
        let latLangs = layer._latlngs[0];
        for (let index = 0; index < latLangs.length; index++) {
            let newLocation = [latLangs[index].lat, latLangs[index].lng];
            array.push(newLocation);
        }

        for (let index = 0; index < this._containers.length; index++) {
            const element = this._containers[index];

            var inPolygon = pointInPolygon([element.latitude, element.longitude], array); // true

            if (inPolygon) {
                let poligonDetail = new PoligonDetail();
                poligonDetail.poligonId = id;
                poligonDetail.discriminator = "container";
                poligonDetail.discriminatorId = element.id;
                
                try {
                    this._simulationService.addDetail(poligonDetail);
                } catch (error) {
                    console.warn(error);

                }
            }
        }
    };



    public onAddLocationClick(e) {
        this.markerMasterOpen = false;
        this.containerMarkerOpen = false;
        this.envanterMarkerOpen = false;
        if (this.polygonMarkerOpen) {
            this._toastService.toastFail(this._translateService.instant("STOP_THE_ACTIVE_POLYGON_SELECTION"));
            return;
        }
        this.markerOpen = true;
        this._toastService.toastWarning(this._translateService.instant("MARKING_IS_ACTIVE_PLEASE_MARK_A_PLACE_ON_THE_MAP"));
        e.stopPropagation();
    }

    public onAddContainerClick(e) {
        this.markerMasterOpen = false;
        this.markerOpen = false;
        this.envanterMarkerOpen = false;
        if (this.polygonMarkerOpen) {
            this._toastService.toastFail(this._translateService.instant("STOP_THE_ACTIVE_POLYGON_SELECTION"));
            return;
        }
        this.containerMarkerOpen = true;
        this._toastService.toastWarning(this._translateService.instant("MARKING_IS_ACTIVE_PLEASE_MARK_A_PLACE_ON_THE_MAP"));
        e.stopPropagation();
    }

    public onAddMasterLocationClick(e) {

        this.markerOpen = false;
        this.envanterMarkerOpen = false;
        this.containerMarkerOpen = false;
        if (this.polygonMarkerOpen) {
            this._toastService.toastFail(this._translateService.instant("STOP_THE_ACTIVE_POLYGON_SELECTION"));
            return;
        }
        this.markerMasterOpen = true;
        this._toastService.toastWarning(this._translateService.instant("MARKING_IS_ACTIVE_PLEASE_MARK_A_PLACE_ON_THE_MAP"));
        e.stopPropagation();
    }
    public onCancelLocationClick(e) {
        this.markerOpen = false;
        this.envanterMarkerOpen = false;
        this.markerMasterOpen = false;
        this._toastService.toastFail(this._translateService.instant("MARKING_IS_PASSIVE"));
        e.stopPropagation()
    }


    async ngAfterViewInit(): Promise<void> {
        await this.initMap();
        await this.getLocationList();
        await this.getPoligonList();
        setTimeout(() => {
            this.makeCapitalMarkers(this.map);
        }, 500);
    }
    async getPoligonList() {
        this.poligons = []
        try {
            this.poligons = await this._simulationService.getPoligons(this.companyId);
        } catch (error) {
            console.warn(error);

        }

        this.poligons.forEach(item => {

            var poligonList = new Array();
            let points = item.points.split("*");
            points.forEach(item => {
                var location = item.split([","]);
                poligonList.push(new L.LatLng(location[0], location[1]));
            });
            var firstpolyline = new L.polygon(poligonList, {
                color: 'gray',
                weight: 3,
                opacity: 0.3,
                smoothFactor: 1
            });
            firstpolyline.bindTooltip(item.name);

            this.map.addLayer(firstpolyline);




        })
    }

    async makeCapitalMarkers(map: L.map): Promise<void> {
        this._containers.forEach(x => {
            if (x.latitude && x.longitude) {
                if (x.containerType == true) {
                    const marker = L.marker([x.latitude, x.longitude], { icon: new ContainerIcon({ iconUrl: 'assets/img/end.png' }) });
                    marker.bindPopup(()=> {
                        let html = `<div> ${this._translateService.instant("TITLE")} : ${x.streetDesc}</div>`;
                        return html;
                    });
                    marker.addTo(map).openPopup();
                    return;
                }
                var calc=0;
                if(x.device.deviceLatestStatus){
                    calc=(((parseInt(x.altitude) - parseInt(x.deadZone))-(parseInt(x.device.deviceLatestStatus.mesafe) - parseInt(x.deadZone))) * 100) 
                    / (parseInt(x.altitude) - parseInt(x.deadZone))
                    if(calc<0){
                        calc=0;
                    }
                    else if(calc>100){
                        calc=100;
                    }
                }
                var calculate = x.device.deviceLatestStatus ? calc : -1;
                var map_icon;
                // cengiz bey isteği çöp konteyneri 4 farklı renge bölme
                if (calculate <= this.appConfigService.apiConfig["container-msf-yellow"]) {
                    map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-green.png' });
                }
                else if (calculate <= this.appConfigService.apiConfig["container-msf-orange"]) {
                    map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-yellow.png' });
                }
                else if (calculate <= this.appConfigService.apiConfig["container-msf-red"]) {
                    map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-orange.png' })
                }
                else {
                    map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-red.png' })
                }

                const marker = L.marker([x.latitude, x.longitude], { icon: map_icon });

    var fullnessValue = calculate == -1 ? this._translateService.instant("UNDEFINED_VALUE") : calculate.toString().slice(0, 4);
                marker.bindPopup(this.makeCapitalPopup(x.street, x.streetDesc, fullnessValue,x.deviceId,x.name));
                marker.addTo(map).openPopup();
            }
        });
        var map_car_icon = new LeafIcon({ iconUrl: 'assets/img/garbage-truck.png' });
        this.carlist.forEach(x => {
            if (x.eLatitude && x.eLongitude) {
                const marker = L.marker([x.eLatitude, x.eLongitude], { icon: map_car_icon });
                marker.bindPopup(this.makeCarPopup(x));
                marker.addTo(map).openPopup();
            }
        })
    }


    makeCapitalPopup(street: string, streetDesc, fullness: string,deviceID:string,name:string): string {
        let html = `<div> ${this._translateService.instant("OCCUPANCY")} : % ${fullness}</div>`;
        if(deviceID!=null){
            html += `<div> ${"No"}: ${deviceID}</div>`;
        }
        html += `<div> ${this._translateService.instant("NAME")}: ${name}</div>`;
        html += `<div> ${this._translateService.instant("TITLE")}: ${streetDesc}</div>`;
        html += `<div> ${this._translateService.instant("STREET")}: ${street}</div>`;
        return html;
    }
    makeCarPopup(data: Car): string {
        let html = `<div>${this._translateService.instant("PLATE")} : ${data.plate}</div>`;
        return html;
    }

    mySetLocation(map: L.map) {

        var options = {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
        };

        navigator.geolocation.getCurrentPosition(
            function (position) {

                let lat = position.coords.latitude;
                let long = position.coords.longitude;

                var LeafIcon = L.Icon.extend({
                    options: {
                        iconSize: [30, 30],
                        iconAnchor: [12, 41],
                        popupAnchor: [1, -34],
                        tooltipAnchor: [16, -28],
                        shadowAnchor: [4, 62]
                    }
                });

                var map_icon = new LeafIcon({ iconUrl: 'assets/img/marker.png' });
                var marker = L.marker([lat, long], { icon: map_icon });
                marker.addTo(map);


                setTimeout(() => { map.flyTo(new L.LatLng(lat, long), 11) }, 2000)



            },
            ()=> {
                this._toastService.toastFail(this._translateService.instant("DEVICE_LOCATION_INFORMATION_COULD_NOT_BE_OBTAINED"))
            },
            options
        );


    }

    public DrawPolygonInContainerControl(container: Container) {
        this.poligons.forEach(poligon => {
            var poligonList = new Array();
            let points = poligon.points.split("*");
            points.forEach(item => {
                var array = new Array();
                var location = item.split([","]);
                array.push(parseFloat(location[0]), parseFloat(location[1]))
                poligonList.push(array);
            });

            var inPolygon = pointInPolygon([container.latitude, container.longitude], poligonList); // true
            if (inPolygon) {
                let poligonDetail = new PoligonDetail();
                poligonDetail.poligonId = poligon.id;
                poligonDetail.discriminator = "container";
                poligonDetail.discriminatorId = container.id;
                try {
                    
                    this.containerAdd(poligonDetail)

                } catch (error) {
                    console.warn(error);

                }
            }
        })
    }

}
